import ActivityLog from '@components/activityLog/ActivityLog'
import { selectSelectedBusinessProfile } from '@store/business/BusinessProfileReducer'
import { useAppSelector } from '@store/hooks'
import { Spin } from 'antd'

const View = () => {
  const item = useAppSelector(selectSelectedBusinessProfile())

  if (!item) {
    return <Spin />
  }

  return (
    <ActivityLog.Timeline
      entity="business-profile"
      entityId={item.id}
      cardProps={{
        style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
      }}
    />
  )
}

export default View
